import {
  LayoutDashboard,
  Settings,
  Users,
  Clock3,
  Map,
  Building2,
  Forklift,
  Smartphone,
  Wrench,
  ShieldCheck,
  Award,
  Radio,
  Activity,
  Gauge,
  FileText,
  ClipboardCheck,
  HeartPulse,
  FileBarChart,
  TrendingUp,
  BarChart3,
  Circle,
  LucideIconData,
} from 'lucide-angular';

/**
 * Mapa nombre→ícono Lucide. El backend manda el ícono como string (ej.
 * "LayoutDashboard"); aquí se resuelve al dato que entiende `lucide-icon`.
 */
const MENU_ICONS: Record<string, LucideIconData> = {
  LayoutDashboard,
  Settings,
  Users,
  Clock3,
  Map,
  Building2,
  Forklift,
  Smartphone,
  Wrench,
  ShieldCheck,
  Award,
  Radio,
  Activity,
  Gauge,
  FileText,
  ClipboardCheck,
  HeartPulse,
  FileBarChart,
  TrendingUp,
  BarChart3,
};

/** Resuelve el nombre de ícono del backend; usa `Circle` como respaldo si no se conoce. */
export function resolveMenuIcon(name: string): LucideIconData {
  return MENU_ICONS[name] ?? Circle;
}
